export default "__VITE_ASSET__DPbFeeTM__";